import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import Select from 'react-select'
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
const ModalCreateEncuesta =({handleShowPopup,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
  const obtenerFechaActualLocal = () => {
      const ahora = new Date();
      const anio = ahora.getFullYear();
      const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
      const dia = String(ahora.getDate()).padStart(2, '0');
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
    
      return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    };
  // console.log(groupSelected)
  useEffect(()=>{
    buscar_host()
  },[])
  const [loadingM,setLoadingM]=useState(false);
  const [IpValid,setIpValid]=useState(true)
  const [matchPassword,setMatchPassword]=useState(false)
  const [disabled,setDisabled]=useState(true)
  const [hosts,sethost]=useState([])
  const [ManttoData,setManttoData]=useState({
      // name_brand:(editActive)?groupSelected.name_brand:"",
          code: (editActive)?groupSelected.code:"",
          title: (editActive)?groupSelected.title:"",
          description:(editActive)?groupSelected.description:"",
          trigger_id: (editActive)?((groupSelected.trigger_id==""||groupSelected.trigger_id==null)?null:groupSelected.trigger_id):null,
          period_id: (editActive)?((groupSelected.period_id==""||groupSelected.period_id==null)?null:groupSelected.period_id):null,
        
      })
  const [OptionsData,setOptionsData]=useState([{
          survey_id: 1,
          question_text: "",
          type: "Texto",
          options: []
          }])
  const [hostName,setHostName]=useState("")
  const [hostLocation,setHostLocation]=useState("")
  const [hostActivate,setHostActivate]=useState(0)
  // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
  const [msgError,setMsgError]=useState("")
  const [listSearchIP,setListSearchIP]=useState(false)
  const dataTriggers=useFetch('cassia/surveys/survey_triggers','','','GET',server)
  const dataPeriods=useFetch('cassia/surveys/survey_periods','','','GET',server)


  const levels=[
      {
          id:1,
          name:"Texto",
          cassia_criticality_id:1
      },
      {
          id:2,
          name:"Multiple",
          cassia_criticality_id:2
      },
      
  ]
  const options = [
      { value: 1, label: 'Texto' },
      { value: 2, label: 'Multiple' }, // Deshabilitada
    ];
  const defaultOption = { value: 1, label: 'Texto' };
  const handleChange=(e)=>{
      // console.log(e.target.name)
      const {name,value}=e.target
      if(e.target.name==="criticality"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:value===""?0:(parseInt(value))
              }
              
          })
      }  else if(e.target.name==="status"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:(value=="Inactivo")?"Activo":"Inactivo"
              }
              
          })
      }else{
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:value
              }
              
          })
      }
          
        
     
      if(e.target.name==="ip"){
          if(value==""){
              setHostLocation("")
              setHostActivate(0)
              setIpValid(true)
              sethost([])
              setHostName("")
              setHostLocation("")
          }else{
              
          }
         
         
        }

      
      
    }

  useEffect(()=>{
   
        if( ManttoData.name_brand=="" || ManttoData.mac_address_brand_OUI=="" ){
            // console.log('disabled')
            setDisabled(true)
        }else{
            // console.log('no disabled')
            setDisabled(false)
        }
  },[ManttoData])


  const RegistrarEncuesta=()=>{
    
    let method='POST'
    let url_add=''
    if(editActive){
        method='PUT'
        url_add=groupSelected.brand_id
    }
    
    
    let  body ={}
    
   
   
    // console.log(body)
    setLoading(true)
      const fetchDataPost = async () => {
        
     try {
        // console.log(method,server.url+'/api/v1/cassia/brands/')
      
        // console.log(localStorage.getItem('access_token'))
          const response = await fetch(server.url+'/api/v1/cassia/brands/'+url_add, {
            method: method,  
            headers: {
               "Accept": "application/json",
              // 'Content-Type': 'application/json',
              'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              },
            body: JSON.stringify(ManttoData),
          });
        //  console.log(response)
          if (response.ok) {
            
            const data1 = await response.json();
            setLoading(false)
            // Manejo de la respuesta
            setData(data1)
           
            handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
            // console.log(data1);
            closCreateCisModal()
          setRegisterIsValid(true)
          
          const timer = setTimeout(() => {
            setRegisterIsValid(false)
            setEditActive(false)
            closCreateCisModal()
          }, 3000);
        
          } else {
            const data1 = await response.json();
            handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
            setHostName("")
        setLoading(false)
          setError(error)
          closCreateCisModal()
          setRegisterIsValid(true)
          console.error(error);
        }
      };
  
      fetchDataPost();
      
}
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const buscar_host=()=>{
      // console.log("buscar_host")
      
      setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
          // console.log(server.url+'/api/v1/cassia/ci/search_host/'+ip)
          const response = await fetch(server.url+'/api/v1/cassia/surveys/_surveys/'+groupSelected.id+'/detailed_responses', {
              method: 'GET',  
              headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
              },
            });
          //   console.log(response)
            if (response.ok) {
              const data1 = await response.json();
              setLoadingM(false)
              sethost(data1.message)
              setDisabled(true)
            } else {
              const data1 = await response.json();
              // console.log(data1)
              throw new Error('Error en la solicitud');
            }
          } catch (error) {
            console.error(error);
          }
        };
    
        fetchDataPost();
      
  }
  const [typeQuestion,setTypeQuestion]=useState(1)
  // console.log("tipo pregunta",typeQuestion)
  const changeTypeQuestion=(selected,element,index)=>{
      
      // console.log(selected,element,index)
      const updatedData = [...OptionsData];
  // Modificar el objeto en la posición indicada
  updatedData[index] = { ...updatedData[index], type: selected.label };
  // Actualizar el estado
  setOptionsData(updatedData);
          // setOptionsData((prevState)=>{
          //     return {
          //         ...prevState,
          //         ['trigger_id']:option.value===0?null:(parseInt(option.value))
          //     }
              
          // })
      
      
      // setManttoRelation(option.value)
          
  }
  const changeOption=(option,index)=>{
      
      // console.log(option)
     
      if(option.filter=="trigger"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['trigger_id']:option.value===0?null:(parseInt(option.value))
              }
              
          })
      }else if(option.filter=="period"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['period_id']:option.value===0?null:(parseInt(option.value))
              }
              
          })
      }else if(option.filter=="Estados"){
          setTypeQuestion(parseInt(option.value))
      }
      
      // setManttoRelation(option.value)
          
  }

  const [fecha, setDate] = useState('2023-09-28')

  const [resultList,setResultList]=useState([])


  //   console.log(resultList)


  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  var dataList = searchTerm === "" ? hosts : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value);setPageActual(1);
  };
  const {code,title,description,trigger_id,period_id}=ManttoData;
  return(
    <>
    <div className="modal-GS-content">
    <div className='card-modal-gs modal-verificate'>
            <div className='head-card-modal-gs'>
                <div className='title-head-card-modal-gs'>
                  {lang[languaje]['respuestas'].toUpperCase()}
                </div>
            </div>
            <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                <div className='half-content-card-modal-gs' style={{width:'100%'}}>
                <>
                <div className='head-cis'>
                    <div className='head-cis-half'>
                        <div className='cont-head-cis-info'>
                            <div style={{fontWeight:'bold'}}>{capitalizeFirstLetter(lang[languaje]['encuesta'])}:</div>
                            &nbsp;&nbsp;
                            <div >{title}</div>
                        </div>
                        <div className='cont-head-cis-info'>
                        <div style={{fontWeight:'bold'}}>{capitalizeFirstLetter(lang[languaje]['codigo'])}:</div>
                            &nbsp;&nbsp;
                            <div >{code}</div>
                        </div>
                    </div>
                    <div className='head-cis-half'>
                      <div className='cont-head-cis-info'>
                        <div style={{fontWeight:'bold'}}>{capitalizeFirstLetter(lang[languaje]['descripcion'])}:</div>
                              &nbsp;&nbsp;
                              <div >{description}</div>
                          
                      </div>
                      <div className='cont-head-cis-info'>
                      <div style={{fontWeight:'bold'}}>{capitalizeFirstLetter(lang[languaje]['disparador'])}:</div>
                              &nbsp;&nbsp;
                              <div >{(groupSelected.trigger_name==null || groupSelected.trigger_name=="")?'N/A':groupSelected.trigger_name}</div>
                      </div>
                      <div className='cont-head-cis-info'>
                      <div style={{fontWeight:'bold'}}>{capitalizeFirstLetter(lang[languaje]['periodo'])}:</div>
                              &nbsp;&nbsp;
                              <div >{groupSelected.period_name}</div>
                      </div>
                    </div>
               </div>
<div className='head-cis'>
<div className='title-cis'>
            <Search
                searchResults={searchResults}
                setSearchResults={setSearchResults}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                onSearch={handleSearch}
                dataObject={hosts}
                searchResult={searchResult}
                setSearchResult={setSearchResult}
                languaje={languaje}
              />
      <div className={"cont-result-registers"+mode} style={{width:'25%',bottom:'0px'}}>
     
              <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                &nbsp;
                {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                  dataList.length +
                  ") " 
                  }
              </p> 
      </div>
     
           
         
            </div>
            
        </div>
        <div className='cont-cis' style={{height:'70%'}}>
        <>
  <div className="main-panel-cis">
  <div className="compact-content-portafolio">
  <div className={"content-portafolio-head"+mode}>
    {
    // (contRowsSelected!=0)?
    
      // :''
          }
          </div>
    <div className="content-portafolio">
      <div className="cont-portafolio-table">
        <div className="content-card-portafolio" id="content">
         
        <div className="cont-table-portafolio">
  <div className={"head-table-portafolio"+mode}>
  <div className="compact-head-table-portafolio">
  {/* <div className="field-head-table-mantenimiento field-medium">  <div className='cont-checkbox'>
             <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}} onChange={()=>console.log("all")}  onClick={()=>handleSelectAll()} ></input>
            </div></div> */}
    {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
    <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{capitalizeFirstLetter(lang[languaje]['nombre'])} </div>
    <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{capitalizeFirstLetter(lang[languaje]['correo'])} </div>
    <div className="field-head-table-mantenimiento field-medium" style={{width:'20%'}}>{capitalizeFirstLetter(lang[languaje]['pregunta'])}</div>
    <div className="field-head-table-mantenimiento field-medium" style={{width:'25%'}}>{capitalizeFirstLetter(lang[languaje]['respuesta'])}</div>
    <div className="field-head-table-mantenimiento field-medium" style={{width:'15%'}}>{capitalizeFirstLetter(lang[languaje]['fecha'])}</div>
    </div>
  </div>
  <div className="body-table-portafolio">
   
  <>
  <div className="cont-row-user-list">
    {(
      dataList
        .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
        .map((elemento, indice) => (
          <div
            className={"row-table-portafolio"+mode}
            key={indice}
          >
             {/* <div className="field-body-table-mantenimiento field-medium">
             <div className='cont-checkbox'>
             <input type='checkbox' checked={poolRows.some((row) => row === elemento.hostid)} className='NotifiCheckBox ' style={{height:'15px'}}   onChange={()=>rowSelected(elemento)} ></input>
            </div>
            </div> */}
            {/* <div className="field-body-table-mantenimiento field-small">
              {elemento.hostid}
            </div> */}
            <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
              {elemento.user_name}
            </div>
            <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
              {elemento.user_email}
            </div>
            <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
              {elemento.question_text}
            </div>
            <div className="field-body-table-mantenimiento field-larger" style={{width:'25%'}}>
              {elemento.answer}
            </div>
            <div className="field-body-table-mantenimiento field-larger" style={{width:'15%'}}>
              {elemento.submitted_at}
            </div>
            
           
            
            
           
          </div>
        ))
    )}
    { (dataList.length == 0 ) ? (
      <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
    ) : (
      ""
    )}
  </div>
  
</>
  </div>
</div>
        </div>
      </div>

      </div>
      <div className={"content-portafolio-footer"+mode}>
      <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
        
        {/* <div className={"cont-half-display-paginador"+mode}>
        <p style={{  textAlign: "center" }}>
                        &nbsp;
                        {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                  </p> 
              
        </div> */}
      </div>  
      <div className="cont-display-paginador" style={{width:'60%'}}>
                <Paginador  pages={pages}
                            pageActual={pageActual}
                            setPageActual={setPageActual}
                            mode={mode}></Paginador>
      </div>
      <div className="cont-display-paginador" style={{width:'50%'}}>
        <div className={"cont-half-display-paginador"+mode}>
                  
        <div>
  <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
  <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
    <option value={10}>10</option>
    <option value={50} >50</option>
    <option value={100}>100</option>
    <option value={500}>500</option>
    <option value={1000}>1000</option>
  </select>

  
</div>
        </div>
        <div className={"cont-half-display-paginador"+mode} >
        <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall) !important'}}>
                        &nbsp;
                        {"(" +
                    (startLimit + 1) +
                    " - " +
                    (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                      ?  parseInt(pageActual ) * parseInt(limitList)
                      : dataList.length) +
                    ")  "+lang[languaje]['de']+" " +
                    dataList.length +
                    " "+lang[languaje]['resultados']}
                  </p>
              
        </div>
      </div>  
                
    </div>
    </div>
  </div>
  
</>
            
        </div>
</>
  
                </div>
                
            </div>
        </div>
        </div>
    </>
  )
}

export default ModalCreateEncuesta